import { render, staticRenderFns } from "./storagechange.vue?vue&type=template&id=644ed800&scoped=true"
import script from "./storagechange.vue?vue&type=script&lang=js"
export * from "./storagechange.vue?vue&type=script&lang=js"
import style0 from "./storagechange.vue?vue&type=style&index=0&id=644ed800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644ed800",
  null
  
)

export default component.exports